import React from 'react';
import PropTypes from 'prop-types';

export const Step = ({ stepNumber, children, icon }) => {
    return (
        <div className={`step step-${stepNumber}`}>
            <img className='step-image' src={icon} alt={`step-${stepNumber}`} />
            <div className="step-children">{children}</div>
        </div>
    );
};

Step.propTypes = {
    stepNumber: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
    icon: PropTypes.string.isRequired,
};
